module.exports = __webpack_public_path__ + "static/media/Clock.e3b5674e.mp3";